import React from 'react';
import styles from './index.module.scss';

export default function Title({ children = null }) {
  return <p className={styles.container}>{children}</p>;
}
